import React from 'react';
import { Alert, Card, CardBody, Col, Row } from 'reactstrap';
import { useFormikContext } from 'formik';
import * as Yup from 'yup';

import OInput from '../../../../Components/OElements/OInput';
// TODO [extensibilidad]: La auto-block de residuos podría inyectarse via
// workflow config (config.observaciones.buildAutoBlock) en vez de importar directamente.
import {
	buildResiduosObservacionesAutoBlock,
	mergeObservacionesGuiaForPayload,
} from '../utils/residuosObservacionesAuto';

export const ObservacionesSectionSpec = {
	getInitialValues: () => ({
		observaciones_guia: '',
	}),
	getValidationSchema: () =>
		Yup.object({
			// Observaciones es opcional
		}),
	toPayload: values => ({
		dtefacele: {
			CamposLibres: {
				ObservacionesGuia: mergeObservacionesGuiaForPayload(values),
			},
		},
	}),
};

export const ObservacionesSection = () => {
	const validation = useFormikContext();
	const isResiduos = validation.values.guide_category === 'residuos';
	const autoBlock = isResiduos
		? buildResiduosObservacionesAutoBlock(validation.values)
		: '';

	return (
		<Card className='border mb-0'>
			<CardBody className='p-4'>
				<Row className='g-3'>
				{isResiduos && autoBlock ? (
					<Col lg={12}>
						<Alert color='light' className='mb-0 border'>
							<small className='text-muted d-block mb-1'>
								Texto que se incluirá automáticamente al inicio de las
								observaciones del DTE (cuando hay items valorizables):
							</small>
							<pre className='mb-0 small text-body' style={{ whiteSpace: 'pre-wrap' }}>
								{autoBlock}
							</pre>
						</Alert>
					</Col>
				) : null}
					<Col lg={12}>
						<OInput
							id='observaciones_guia'
							name='observaciones_guia'
							type='textarea'
							label='Observaciones'
							className='form-control'
							rows={4}
							validation={validation}
							placeholder='Escriba las observaciones de la guía de despacho'
						/>
					</Col>
				</Row>
			</CardBody>
		</Card>
	);
};
